module.exports = "p{\n     margin: 0 9px 13px;\n}\n@media screen and (max-width: 640px) {\n#divBtns{\n          margin-top: 60px !important;\n}\n  h3{\n    /*font-size:16px !important; */\n     margin-left: 15px !important;\n     margin-top: 14px !important;\n  }\n  a{\n        height: 107px !important;\n}\n.p{\n    margin: 0 9px 40px !important;\n}\n/*#playlistDuration{\n    margin-top: 8px !important;\n}*/\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-discoveries/account-list-detail/account-list-detail.component.css
// module id = ./src/app/my-discoveries/account-list-detail/account-list-detail.component.css
// module chunks = main